import { StringUtils } from "./StringUtils";
import { List } from "./List";
import { HashSet } from "./HashSet";
import { Guid, ValueEncoder } from ".";

export interface Iterable<T> {
    ForEach: (callbackfn: (val: T, index: number, arr: T[]) => void, thisArg?: any) => void;
    Some: (callbackfn: (val: T, index: number, arr: T[]) => boolean, thisArg?: any) => boolean;
    Every: (callbackfn: (val: T, index: number, arr: T[]) => boolean, thisArg?: any) => boolean;
}

export interface IEquatable {
    GetHashCode: () => number;
    Equals: (obj: any) => boolean;
}

export interface IComparable {
    CompareTo: (obj: any) => number;
}

export interface IAddable<T> {
	Add: (value: T) => void;
}

export class ObjUtils {
	//private static referenceCount: number = 0;

	private static uvobjidGen: number = 0;

    //public static GetNextRefId(): number {
    //    return ObjUtils.referenceCount++;
    //}

    public static GetHashCode(obj: any): number {
        if (obj == null || obj === undefined) {
            return StringUtils.GetHashCode(obj + '');
        }

        if (obj.GetHashCode) {
            return obj.GetHashCode();
        }

        var result = '';

        switch (ObjUtils.GetType(obj)) {
            case 'undefined':
            case 'null':
            case 'boolean':
            case 'number':
            case 'regexp':
                result = obj + '';
                break;
            case 'date':
                result = '♣' + obj.getTime();
                break;
            case 'string':
                result = '♠' + obj;
                break;
            case 'array':
                var hashes = [];
                for (var i = 0; i < obj.length; i++) {
                    hashes[i] = ObjUtils.GetHashCode(obj[i]);
                }
                result = '♥' + hashes.join('⁞');
                break;
			default:
                //result = '♦' + obj;
				if (obj.uvobjid === undefined)
					obj.uvobjid = ++ObjUtils.uvobjidGen;
				result = '♦' + obj.uvobjid;
                break;
        }

        return StringUtils.GetHashCode(result);
    }

    public static Equals(a: any, b: any) {
        if (!a && !b)
            return true;
        if (!a || !b)
            return false;

        if (a.Equals)
			return a.Equals(b);

		if (a instanceof Date && b instanceof Date)
			return (a.getTime() === b.getTime());

        return a === b;
    }

    public static Compare(a: any, b: any, name: string, output: string[]): void {
        if (!ObjUtils.Equals(a, b)) {
            output.push(`${name} values differ: ${ObjUtils.ToString(a)}, ${ObjUtils.ToString(b)}`);
        }
    }

    public static ToString(a: any): string {
        if (a.toString) {
            return a.toString();
        }
        if (a.ToString) {
            return a.ToString();
        }
        return "" + a;
	}

    public static GetType(obj: any): string {
        var funcNameRegex = /function (.{1,})\(/;
        var results = (funcNameRegex).exec((obj).constructor.toString());
        return (results && results.length > 1) ? results[1].toLowerCase() : "";
    }

    public static CompareTo(a: any, b: any): number {
        if (ObjUtils.Equals(a, b))
            return 0;

        if (b == null)
            return 1;

        if (a.CompareTo)
            return a.CompareTo(b);


        var thisHash = ObjUtils.GetHashCode(a);
        var otherHash = ObjUtils.GetHashCode(b);

        if (thisHash < otherHash)
            return -1;

        return 1;
	}

    public static ListEquals<T>(a: List<T>, b: List<T>) {
        if (!a && !b)
            return true;

        if (!a || !b)
            return false;

		if (a.Count != b.Count)
			return false;

		for (var i = 0; i < a.Count; ++i) {
			if (!ObjUtils.Equals(a.Get(i), b.Get(i)))
				return false;
		}

		return true;
	}

    public static SetEquals<T>(a: HashSet<T>, b: HashSet<T>) {
        if (!a && !b)
            return true;

        if (!a || !b)
            return false;

		if (a.Count != b.Count)
			return false;

		let aList = a.ToList();
		for (let i = 0; i < aList.Count; ++i) {
			if (!b.Contains(aList.Get(i)))
				return false;
		}

		return true;
    }

    public static SetDifference<T>(a: HashSet<T>, b: HashSet<T>): HashSet<T> {
        let result = new HashSet<T>();

        a.ForEach((value: T) => {
            if (!b.Contains(value)) {
                result.Add(value);
			}
        });

        return result;
    }

    public static RemoveArrayElement<T>(arr: T[], value: T): boolean {
        return ObjUtils.RemoveArrayElementPredicate(arr, (elem: T) => elem === value);
    }

    public static RemoveArrayElementPredicate<T>(arr: T[], predicate: (value: T) => boolean): boolean {
        let index = arr.findIndex(predicate);
        if (index >= 0) {
            arr.splice(index, 1);
            return true;
        }
        else {
            return false;
        }
    }

    public static GuidToString(guid: string | Guid): string {
        if (guid instanceof Guid) {
            return ValueEncoder.EncodeGuid(guid as Guid);
        }
        else {
            return (guid as string);
        }
	}
}
